import * as React from 'react'
import { TableCell } from '@mui/material'

const CustomCell = (props) => {
  const getRenderValue = () => {
    if (
      props.columnDef.emptyValue !== undefined &&
      (props.value === undefined || props.value === null)
    ) {
      return getEmptyValue(props.columnDef.emptyValue)
    }
    if (props.columnDef.render) {
      if (props.rowData) {
        return props.columnDef.render(props.rowData, 'row')
      } else {
        return props.columnDef.render(props.value, 'group')
      }
    } else if (props.columnDef.type === 'boolean') {
      const style = { textAlign: 'left', verticalAlign: 'middle', width: 48 }
      if (props.value) {
        return <props.icons.Check style={style} />
      } else {
        return <props.icons.ThirdStateCheck style={style} />
      }
    } else if (props.columnDef.type === 'date') {
      if (props.value instanceof Date) {
        return props.value.toLocaleDateString()
      } else {
        return props.value
      }
    } else if (props.columnDef.type === 'time') {
      if (props.value instanceof Date) {
        return props.value.toLocaleTimeString()
      } else {
        return props.value
      }
    } else if (props.columnDef.type === 'datetime') {
      if (props.value instanceof Date) {
        return props.value.toLocaleString()
      } else {
        return props.value
      }
    } else if (props.columnDef.type === 'currency') {
      return getCurrencyValue(props.columnDef.currencySetting, props.value)
    }

    return props.value
  }

  const getEmptyValue = (emptyValue) => {
    if (typeof emptyValue === 'function') {
      return props.columnDef.emptyValue(props.rowData)
    } else {
      return emptyValue
    }
  }

  const getCurrencyValue = (currencySetting, value) => {
    if (currencySetting !== undefined) {
      return new Intl.NumberFormat(
        currencySetting.locale !== undefined ? currencySetting.locale : 'en-US',
        {
          style: 'currency',
          currency:
            currencySetting.currencyCode !== undefined
              ? currencySetting.currencyCode
              : 'USD',
          minimumFractionDigits:
            currencySetting.minimumFractionDigits !== undefined
              ? currencySetting.minimumFractionDigits
              : 2,
          maximumFractionDigits:
            currencySetting.maximumFractionDigits !== undefined
              ? currencySetting.maximumFractionDigits
              : 2,
        },
      ).format(value !== undefined ? value : 0)
    } else {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      }).format(value !== undefined ? value : 0)
    }
  }

  const handleClickCell = (e) => {
    if (props.columnDef.disableClick) {
      e.stopPropagation()
    }
  }

  const getStyle = () => {
    let cellStyle = {
      color: 'inherit',
      borderBottom: '1px solid #e0e0e0',
    }

    if (typeof props.columnDef.cellStyle === 'function') {
      cellStyle = {
        ...cellStyle,
        ...props.columnDef.cellStyle(props.value, props.rowData),
      }
    } else {
      cellStyle = { ...cellStyle, ...props.columnDef.cellStyle }
    }

    if (props.columnDef.disableClick) {
      cellStyle.cursor = 'default'
    }

    return { ...props.style, ...cellStyle }
  }

  return (
    <TableCell
      size={props.size}
      {...props.cellProps}
      style={getStyle()}
      colSpan={props.colSpan}
      align={
        ['numeric', 'currency'].indexOf(props.columnDef.type) !== -1
          ? 'right'
          : 'left'
      }
      onClick={handleClickCell}
    >
      {props.children}
    </TableCell>
  )
}

export default CustomCell
